/**
 * Journey OpenAI personalization. Disabled in production builds unless you set
 * REACT_APP_JOURNEY_PERSONALIZATION_ENABLED=true (e.g. in Firebase Hosting env / CI).
 */
export function isJourneyPersonalizationEnabled() {
  return process.env.REACT_APP_JOURNEY_PERSONALIZATION_ENABLED === 'true';
}
